import { gql, useMutation } from '@apollo/client';
import { GET_DPO_TASKS } from './useDpoTasksQuery';

const SET_DPO_TASK_APPROVAL = gql`
  mutation SetDpoTaskApproval($companyId: String!, $taskId: String!, $approved: Boolean!) {
    setDpoTaskApproval(companyId: $companyId, taskId: $taskId, approved: $approved)
  }
`;

export interface SetDpoTaskApprovalResult {
  setDpoTaskApproval: boolean;
}

export interface SetDpoTaskApprovalInput {
  companyId: string;
  taskId: string;
  approved: boolean;
}

export function useDpoTaskSetApprovalMutation(companyId: string) {
  return useMutation<SetDpoTaskApprovalResult, SetDpoTaskApprovalInput>(SET_DPO_TASK_APPROVAL, {
    refetchQueries: [{ query: GET_DPO_TASKS, variables: { companyId } }],
  });
}
